// ARQUIVO ATUALIZADO E CORRIGIDO
import React from 'react';

import GlassCard from '../components/ui/Card';
import FocusWidget from '../components/dashboard/FocusWidget';
import WeekViewWidget from '../components/dashboard/WeekViewWidget';
import MetricsWidget from '../components/dashboard/MetricsWidget';
import QuoteMetricsWidget from '../components/dashboard/QuoteMetricsWidget';

const DashboardPage = ({ onClientClick, onTaskClick }) => {
    return (
        <div className="p-4">
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-3xl font-bold text-white">Dashboard</h2>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                
                <GlassCard className="lg:h-[480px] flex flex-col">
                    <FocusWidget onTaskClick={onTaskClick} />
                </GlassCard>

                <GlassCard className="lg:h-[480px] flex flex-col">
                    <WeekViewWidget onTaskClick={onTaskClick} />
                </GlassCard>
                
                {/* --- INÍCIO DA ALTERAÇÃO: Passando a prop onTaskClick para o MetricsWidget --- */}
                <GlassCard className="lg:h-[240px] flex flex-col">
                    <MetricsWidget onTaskClick={onTaskClick} />
                </GlassCard>
                {/* --- FIM DA ALTERAÇÃO --- */}

                <GlassCard className="lg:h-[240px] flex flex-col">
                    <QuoteMetricsWidget />
                </GlassCard>

            </div>
        </div>
    );
};

export default DashboardPage;